import { ListPageSkeleton } from '@practium/ui';

export const ProductsPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={3}
		headerActionsCount={3}
		sidebarWidth="26rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
		stackAt={1100}
	/>
);
